import { message } from 'antd';
import { verifyNationalAddressCode } from 'network/common.api';

export const verifyNationalAddressCodeAndGetData = async (
    nationalAddressCode: string,
    addressType: string = 'address',
): Promise<any | null> => {
    if (!nationalAddressCode || !nationalAddressCode.trim()) {
        return null;
    }

    try {
        const response = await verifyNationalAddressCode({
            nationalAddressCode,
            addressType,
        });

        // Handle both response.data (extracted by POST wrapper) and response.data.data (if nested)
        // POST wrapper extracts: response?.data?.data || response?.data
        // So response.data could be the address object directly, or nested in response.data.data
        const addressData = response?.data?.data || response?.data;

        // Check if we have valid address data
        if (response?.isSuccess && addressData && addressData.address_line_1) {
            return {
                address_line_1: addressData.address_line_1,
                address_line_2: addressData.address_line_2,
                address_line_3: addressData.address_line_3,
                address_line_4: addressData.address_line_4,
                address_line_5: addressData.address_line_5,
                city: addressData.city,
                state: addressData.state,
                pincode: addressData.pincode,
                country: addressData.country,
                latitude: addressData.lat || addressData.latitude,
                longitude: addressData.lng || addressData.longitude,
            };
        }
        return null;
    } catch (error) {
        return null;
    }
};

export const getLocationImage = async (locationImageFile: any, generateTaskImageUrl: any, uploadImageToS3: any) => {
    let file;
    let locationImageDetails;
    if (Array.isArray(locationImageFile) && locationImageFile.length > 0) {
        file = locationImageFile[0];
        const s3Data = {
            fileName: file?.name,
            pocContentType: file?.type?.split('/')?.[1],
            type: 'location_image',
        };

        const response = await generateTaskImageUrl(s3Data);
        if (response?.isSuccess) {
            const upload = await uploadImageToS3(
                new Blob([file as BlobPart], {
                    type: file?.type,
                }),
                response?.data?.pocSignedUrl,
                file?.type,
            );
            if (!upload.isSuccess) {
                message.error('Could not upload file');
                return null;
            }
            const s3UrlToReturn = upload.isSuccess ? response?.data?.pocImageUrl : null;
            locationImageDetails = s3UrlToReturn;
        } else {
            message.error('Could not upload file');
            return null;
        }
    }

    return locationImageDetails;
};
